/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileRefSchema } from './FileRefSchema';
import {
    FileRefSchemaFromJSON,
    FileRefSchemaFromJSONTyped,
    FileRefSchemaToJSON,
} from './FileRefSchema';
import type { JobFileSchema } from './JobFileSchema';
import {
    JobFileSchemaFromJSON,
    JobFileSchemaFromJSONTyped,
    JobFileSchemaToJSON,
} from './JobFileSchema';
import type { RunTaskActionWhenDoneEnum } from './RunTaskActionWhenDoneEnum';
import {
    RunTaskActionWhenDoneEnumFromJSON,
    RunTaskActionWhenDoneEnumFromJSONTyped,
    RunTaskActionWhenDoneEnumToJSON,
} from './RunTaskActionWhenDoneEnum';

/**
 * 
 * @export
 * @interface JobCommonTaskSchema
 */
export interface JobCommonTaskSchema {
    /**
     * 
     * @type {number}
     * @memberof JobCommonTaskSchema
     */
    jobId: number;
    /**
     * 
     * @type {string}
     * @memberof JobCommonTaskSchema
     */
    command: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobCommonTaskSchema
     */
    setupCommands?: Array<string>;
    /**
     * 
     * @type {Array<JobFileSchema>}
     * @memberof JobCommonTaskSchema
     */
    files: Array<JobFileSchema>;
    /**
     * 
     * @type {Array<FileRefSchema>}
     * @memberof JobCommonTaskSchema
     */
    fileRefs: Array<FileRefSchema>;
    /**
     * 
     * @type {RunTaskActionWhenDoneEnum}
     * @memberof JobCommonTaskSchema
     */
    doneAction?: RunTaskActionWhenDoneEnum;
    /**
     * 
     * @type {string}
     * @memberof JobCommonTaskSchema
     */
    remoteOutputPath?: string;
}

/**
 * Check if a given object implements the JobCommonTaskSchema interface.
 */
export function instanceOfJobCommonTaskSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobId" in value;
    isInstance = isInstance && "command" in value;
    isInstance = isInstance && "files" in value;
    isInstance = isInstance && "fileRefs" in value;

    return isInstance;
}

export function JobCommonTaskSchemaFromJSON(json: any): JobCommonTaskSchema {
    return JobCommonTaskSchemaFromJSONTyped(json, false);
}

export function JobCommonTaskSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobCommonTaskSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobId': json['job_id'],
        'command': json['command'],
        'setupCommands': !exists(json, 'setup_commands') ? undefined : json['setup_commands'],
        'files': ((json['files'] as Array<any>).map(JobFileSchemaFromJSON)),
        'fileRefs': ((json['file_refs'] as Array<any>).map(FileRefSchemaFromJSON)),
        'doneAction': !exists(json, 'done_action') ? undefined : RunTaskActionWhenDoneEnumFromJSON(json['done_action']),
        'remoteOutputPath': !exists(json, 'remote_output_path') ? undefined : json['remote_output_path'],
    };
}

export function JobCommonTaskSchemaToJSON(value?: JobCommonTaskSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_id': value.jobId,
        'command': value.command,
        'setup_commands': value.setupCommands,
        'files': ((value.files as Array<any>).map(JobFileSchemaToJSON)),
        'file_refs': ((value.fileRefs as Array<any>).map(FileRefSchemaToJSON)),
        'done_action': RunTaskActionWhenDoneEnumToJSON(value.doneAction),
        'remote_output_path': value.remoteOutputPath,
    };
}

